<div [formGroup]="formGroup" *ngIf="transport != null">
    <mat-radio-group formControlName="planningType">
        <sc-flex [vertical]="true" [stretchContent]="true">
            <mat-radio-button [value]="TransportPlanningType.DEFAULT">
                <sc-dictionary-label
                    dictionaryKey="tmc-yard.common.enum.transport-planning-type.DEFAULT"></sc-dictionary-label>
            </mat-radio-button>
            <mat-radio-button [value]="TransportPlanningType.TIMEFRAME">
                <sc-dictionary-label
                    dictionaryKey="tmc-yard.common.enum.transport-planning-type.TIMEFRAME"></sc-dictionary-label>
            </mat-radio-button>
            <div *ngIf="transport.timing.planningType === TransportPlanningType.TIMEFRAME">
                <sc-content-spacer [vertical]="true" [half]="true"></sc-content-spacer>
                <sc-date-time-field formControlName="timeSlotDate" [label]="'TIMEFRAME' |
    translate:['tmc-yard.common.enum.transport-planning-type.TIMEFRAME',
    translationService.language]" style="width: 100%;"></sc-date-time-field>
            </div>
            <mat-radio-button [value]="TransportPlanningType.IN_ADVANCE">
                <sc-dictionary-label
                    dictionaryKey="tmc-yard.common.enum.transport-planning-type.IN_ADVANCE"></sc-dictionary-label>
            </mat-radio-button>
            <div *ngIf="transport.timing.planningType === TransportPlanningType.IN_ADVANCE">
                <sc-content-spacer [vertical]="true" [half]="true"></sc-content-spacer>
                <sc-date-field formControlName="inAdvanceDate" [label]="'IN_ADVANCE' |
    translate:['tmc-yard.common.enum.transport-planning-type.IN_ADVANCE',
    translationService.language]" style="width: 100%;"></sc-date-field>
            </div>
        </sc-flex>
    </mat-radio-group>

</div>